/**
 * Button Component - Template
 * ===========================
 */

export const BUTTON_TEMPLATE: string = `
<button
  ng-attr-type="{{ $ctrl.type }}"
  class="ec-button"
  ng-class="$ctrl.getButtonClasses()"
  ng-disabled="$ctrl.isDisabled"
  ng-attr-aria-disabled="{{ $ctrl.isDisabled ? 'true' : undefined }}"
  ng-click="$ctrl.handleClick($event)"
  ng-attr-aria-busy="{{ $ctrl.loading ? 'true' : undefined }}"
>
  <!-- ===== SPINNER (loading) ===== -->
  <span
    ng-if="$ctrl.loading"
    class="ec-animate-spin ec-flex-shrink-0"
    ng-class="$ctrl.getIconClasses()"
    ng-bind-html="$ctrl.trustedSpinner"
    aria-hidden="true"
  ></span>

  <!-- ===== ICONO LEADING ===== -->
  <span
    ng-if="!$ctrl.loading && $ctrl.hasLeadingIcon"
    class="ec-flex-shrink-0"
    ng-class="$ctrl.getIconClasses()"
    ng-bind-html="$ctrl.trustedLeadingIcon"
    aria-hidden="true"
  ></span>

  <!-- ===== LABEL (+ SUBTITLE) ===== -->
  <span class="ec-flex ec-flex-col" ng-class="$ctrl.getContentClasses()">
    <span ng-if="$ctrl.hasContent" ng-class="$ctrl.getLabelClasses()" ng-transclude></span>
    <span ng-if="!$ctrl.hasContent" ng-class="$ctrl.getLabelClasses()">{{ $ctrl.label }}</span>
    <span ng-if="$ctrl.subtitle" ng-class="$ctrl.getSubtitleClasses()">{{ $ctrl.subtitle }}</span>
  </span>

  <!-- ===== ICONO TRAILING ===== -->
  <span
    ng-if="$ctrl.hasTrailingIcon"
    class="ec-flex-shrink-0"
    ng-class="$ctrl.getIconClasses()"
    ng-bind-html="$ctrl.trustedTrailingIcon"
    aria-hidden="true"
  ></span>
</button>
`;

export default BUTTON_TEMPLATE;
